import React from "react";
import ViewStaffPage from "../../../../entities/DashboardPage/AccountingModule/StaffPage";

const StaffPage = () => {
  return(
    <ViewStaffPage/>
  )
}

export default StaffPage